import {
  RenterAssessmentParams,
  RenterAssessmentItem,
  RenterAccessmentBadge,
} from '../../interfaces/renter-profile-assessment.interface';

export const housingVoucherAssessmentBadges: {
  hasVoucher: RenterAccessmentBadge;
} = {
  hasVoucher: { title: 'Has housing voucher', badgeColor: 'grey' },
};

export function getHousingVoucherAssessment(assessmentParams: RenterAssessmentParams): RenterAssessmentItem {
  const hasHousingVoucher = assessmentParams.renter?.hasHousingVoucher;
  const uiRepresentation = hasHousingVoucher === undefined ? 'N/A' : hasHousingVoucher ? 'Yes' : 'No';

  let badge: RenterAccessmentBadge | null = null;

  if (hasHousingVoucher === true) {
    badge = housingVoucherAssessmentBadges.hasVoucher;
  }

  return {
    uiRepresentation,
    badge,
  };
}
